// Module
var code = "<div class=\"btpg-footer\" show-on-video-availability> <div class=\"btpg-footer__message\" ng-bind=\"::$ctrl.text\"></div> <div class=\"btpg-footer__video-link\" data-scroll-to-on-click data-scroll-to-selector=\".support-video-spot\" ng-bind=\"::$ctrl.videoBtnText\"> </div> </div>";
// Exports
module.exports = code;